import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CarouselButton from '@/components/atoms/CarouselButton';
import updateDataLayer from '@/utils/gtml';
const ListingPagination = ({ currentPage, totalPages, previousIcon, previousLabel, onClickPrevious, nextIcon, nextLabel, onClickNext, component, }) => {
    if (totalPages < 2) {
        return null;
    }
    return (_jsxs("div", { className: "flex items-center justify-between", children: [_jsxs("div", { className: "inline-flex gap-0.25 text-text-body", children: [_jsx("span", { className: "text-text-links", children: currentPage }), "/", _jsx("span", { children: totalPages })] }), _jsxs("div", { className: "flex gap-2", children: [_jsx(CarouselButton, { variant: "outline", icon: previousIcon, label: previousLabel, onClick: () => {
                            updateDataLayer({
                                event: 'pagination',
                                component: component,
                                pagination_interaction: previousLabel,
                            });
                            onClickPrevious();
                        } }), _jsx(CarouselButton, { variant: "outline", icon: nextIcon, label: nextLabel, onClick: () => {
                            updateDataLayer({
                                event: 'pagination',
                                component: component,
                                pagination_interaction: nextLabel,
                            });
                            onClickNext();
                        } })] })] }));
};
export default ListingPagination;
